import DaIndex from './components/Index.vue'
import DaPubDet from './components/PublicationDetail.vue'
import DaDatAbi from './components/DatosAbiertos.vue'
import NotFound from './components/404.vue'

const routes = [
	{ 
		path: '/', 
		component: DaIndex, 
		name: 'daindex'
	},
	{ 
		path: '/publicacion/:idpublicacion', 
		component: DaPubDet, 
		name: 'dapubdet',
		props: true
	},
	{ 
		path: '/datosabiertos', 
		component: DaDatAbi, 
		name: 'dadatabi'
	},
	{

		path: '*',
		component: NotFound
	}
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js